//@flow
import * as React from 'react';

import { Route, Switch } from 'react-router-dom';
import ImportarPedidoCrudList from './ImportarPedidoCrudList';
import ImportarPedidoEdit from './ImportarPedidoEdit';

export default class ImportarPedidoCrud extends React.PureComponent<{}> {
  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route
            path="/importarPedido"
            exact
            component={ImportarPedidoCrudList}
          />
          <Route
            path="/importarPedido/novo"
            exact
            component={ImportarPedidoEdit}
          />
          <Route path="/importarPedido/:id" component={ImportarPedidoEdit} />
        </Switch>
      </React.Fragment>
    );
  }
}
